export const createIcons = () => {
  const marker_0_50 = document.createElement('img'); // eslint-disable-line camelcase
  marker_0_50.src = '/marker_signal-0_battery-50.png';
  marker_0_50.alt = 'station';
  marker_0_50.width = 30;
  marker_0_50.height = 42.9;

  const marker_0_100 = document.createElement('img'); // eslint-disable-line camelcase
  marker_0_100.src = '/marker_signal-0_battery-100.png';
  marker_0_100.alt = 'station';
  marker_0_100.width = 30;
  marker_0_100.height = 42.9;

  const marker_50_50 = document.createElement('img'); // eslint-disable-line camelcase
  marker_50_50.src = '/marker_signal-50_battery-50.png';
  marker_50_50.alt = 'station';
  marker_50_50.width = 30;
  marker_50_50.height = 42.9;

  const marker_50_100 = document.createElement('img'); // eslint-disable-line camelcase
  marker_50_100.src = '/marker_signal-50_battery-100.png';
  marker_50_100.alt = 'station';
  marker_50_100.width = 30;
  marker_50_100.height = 42.9;

  const marker_100_50 = document.createElement('img'); // eslint-disable-line camelcase
  marker_100_50.src = '/marker_signal-100_battery-50.png';
  marker_100_50.alt = 'station';
  marker_100_50.width = 30;
  marker_100_50.height = 42.9;

  const marker_100_100 = document.createElement('img'); // eslint-disable-line camelcase
  marker_100_100.src = '/marker_signal-100_battery-100.png';
  marker_100_100.alt = 'station';
  marker_100_100.width = 30;
  marker_100_100.height = 42.9;

  const marker_CREATED_50 = document.createElement('img'); // eslint-disable-line camelcase
  marker_CREATED_50.src = '/marker_CREATED_battery-50.png';
  marker_CREATED_50.alt = 'station';
  marker_CREATED_50.width = 30;
  marker_CREATED_50.height = 42.9;

  const marker_CREATED_100 = document.createElement('img'); // eslint-disable-line camelcase
  marker_CREATED_100.src = '/marker_CREATED_battery-100.png';
  marker_CREATED_100.alt = 'station';
  marker_CREATED_100.width = 30;
  marker_CREATED_100.height = 42.9;

  const marker_MAINTENANCE_50 = document.createElement('img'); // eslint-disable-line camelcase
  marker_MAINTENANCE_50.src = '/marker_MAINTENANCE_battery-50.png';
  marker_MAINTENANCE_50.alt = 'station';
  marker_MAINTENANCE_50.width = 30;
  marker_MAINTENANCE_50.height = 42.9;

  const marker_MAINTENANCE_100 = document.createElement('img'); // eslint-disable-line camelcase
  marker_MAINTENANCE_100.src = '/marker_MAINTENANCE_battery-100.png';
  marker_MAINTENANCE_100.alt = 'station';
  marker_MAINTENANCE_100.width = 30;
  marker_MAINTENANCE_100.height = 42.9;

  const imageLineElement = document.createElement('img');
  imageLineElement.src = '/station-line-icon.svg';
  imageLineElement.alt = 'station line';
  imageLineElement.width = 5;
  imageLineElement.height = 60;

  return {
    marker_0_50,
    marker_0_100,
    marker_50_50,
    marker_50_100,
    marker_100_50,
    marker_100_100,
    marker_CREATED_50,
    marker_CREATED_100,
    marker_MAINTENANCE_50,
    marker_MAINTENANCE_100,
    imageLineElement,
  };
};
